const routers = [
  { path: '/infoCollectionTemplate', component: () => import('@/views/PickCollAdmin/template/index.vue') },
  { path: '/ActiveTheme', component: () => import('@/views/PickCollAdmin/ActiveTheme/index.vue') },
  { path: '/module', component: () => import('@/views/PickCollAdmin/module/index.vue') },
  { path: '/moduleInfo', component: () => import('@/views/PickCollAdmin/moduleInfo/index.vue') },
  { path: '/imageTemplate', component: () => import('@/views/PickCollAdmin/imageTemplate/index.vue') },
  { path: '/pickColl/create', component: () => import('@/views/PickCollAdmin/pickColl/Create/index.vue') },
  { path: '/pickColl/CheckImg', component: () => import('@/views/PickCollAdmin/pickColl/CheckImg/index.vue') },
  { path: '/pickColl/Customer', component: () => import('@/views/PickCollAdmin/pickColl/CheckImg/Customer.vue') },
  { path: '/pickColl/role', component: () => import('@/views/PickCollAdmin/role/index.vue') },
  { path: '/pickColl/:type', component: () => import('@/views/PickCollAdmin/pickColl/index.vue') },
  { path: '/photo', component: () => import('@/views/PickCollAdmin/photo/index.vue') },
  { path: '/photoDetail', component: () => import('@/views/PickCollAdmin/photo/detail.vue') }
]

export default routers
